module.exports = __webpack_public_path__ + "img/res6.736543b4.gif";